import { render, staticRenderFns } from "./CourseGroupItemForm.vue?vue&type=template&id=a7207d6c"
import script from "./CourseGroupItemForm.vue?vue&type=script&lang=js"
export * from "./CourseGroupItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports